import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import {
  API_URL,
  SYSTEM_CLIENT_LIST_PASSWORD,
  SYSTEM_CLIENT_LIST_TOKEN,
} from "../../../config/appConfig";

const basePath = `${API_URL.idp}/system/client`;

const getAllSystemClients = async () => {
  return API.get(
    basePath,
    "system_clients_list",
    {},
    {
      password: SYSTEM_CLIENT_LIST_PASSWORD,
      token: SYSTEM_CLIENT_LIST_TOKEN,
    }
  ).then(handleResponse);
};

const createSystemClient = async (payload) => {
  return API.post(basePath, "system_client_create", {
    name: payload.name,
    grantType: payload.grantType,
    allowUserCreation: Boolean(payload.allowUserCreation),
    roles: payload.roles || [],
  }).then(handleResponse);
};

const updateSystemClient = async (clientId, payload) => {
  const body = {
    allowUserCreation: Boolean(payload.allowUserCreation),
  };
  if (payload.name !== undefined) body.name = String(payload.name || "").trim();
  if (payload.grantType !== undefined) {
    body.grantType = Array.isArray(payload.grantType)
      ? payload.grantType.filter(Boolean).map(String)
      : [];
  }
  return API.put(`${basePath}/${clientId}`, "system_client_update", body).then(
    handleResponse
  );
};

const updateSystemClientRoles = async (clientId, roles) => {
  return API.put(`${basePath}/${clientId}/role`, "system_client_update_roles", {
    roles,
  }).then(handleResponse);
};

const refreshSystemClientSecret = async (clientId) => {
  return API.put(
    `${basePath}/${clientId}/refreshclientsecret`,
    "system_client_refresh_secret",
    {}
  ).then(handleResponse);
};

export const systemClientService = {
  getAllSystemClients,
  createSystemClient,
  updateSystemClient,
  updateSystemClientRoles,
  refreshSystemClientSecret,
};
